<script>
import AcceptCollectionDetail from '../../shared/_AcceptCollectionDetail.vue'

export default {
  name: 'DriverOrderAcceptCollection',
  components: {
    AcceptCollectionDetail
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      orderId: this.$route.params.id,
    }
  },
  computed: {
  },
  watch: {

  },
  created() {
    this.breadcrumbs = []
    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true })
    }
    this.breadcrumbs.push({ text: '産廃回収詳細', disabled: true, to: '' })
  },
  methods: {}
}
</script>
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>産廃回収詳細</h2>

    <accept-collection-detail :order-id="orderId" order-type="collection" />

  </v-container>
</template>
<style scoped>

</style>
